<!-- login.component.html -->
<div class="h-screen flex overflow-hidden">
  <!-- Left Side - Reusable Component -->
  <div class="hidden lg:flex lg:w-1/2 lg:flex-shrink-0">
    <div class="w-full overflow-y-auto">
      <app-auth-side-panel></app-auth-side-panel>
    </div>
  </div>

  <!-- Right Side - Login Form -->
  <div class="flex-1 overflow-y-auto bg-gradient-to-br from-white to-violet-50">
    <div class="min-h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div class="max-w-md w-full space-y-8 py-12">
        <!-- Sign In Header -->
        <div>
          <div class="flex justify-center mb-8">
            <img class="h-12 w-auto" src="/assets/logo-default.svg" alt="SalesOMMO">
          </div>
          <h2 class="text-2xl font-bold text-gray-900 text-center">Sign in</h2>
        </div>

        <!-- Login Form -->
        <form [formGroup]="form" (submit)="processLogin()" class="mt-8 space-y-6" method="POST">
          <fieldset class="space-y-5" [disabled]="isLoading">
            <!-- Email Field -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-900 mb-1">
                Email address
              </label>
              <input
                id="email"
                formControlName="email"
                type="email"
                autocomplete="email"
                required
                class="input input-auth"
                [class.border-red-500]="form.get('email')?.touched && form.get('email')?.invalid"
              >
              <div class="pt-3" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
                <p class="ng-invalid pl-1 text-xs text-red-500" *ngIf="form.get('email')?.errors?.['required']">
                  Email is required.
                </p>
                <p class="ng-invalid pl-1 text-xs text-red-500" *ngIf="form.get('email')?.errors?.['email']">
                  Please enter a valid email address.
                </p>
              </div>
            </div>

            <!-- Password Field -->
            <div>
              <div class="flex items-center justify-between mb-1">
                <label for="password" class="block text-sm font-medium text-gray-900">
                  Password
                </label>
                <a routerLink="/forgot-password" class="text-sm text-auth hover:opacity-90 font-medium">
                  Forgot password?
                </a>
              </div>
              <div class="relative">
                <input
                  id="password"
                  formControlName="password"
                  [type]="show_password ? 'password' : 'text'"
                  autocomplete="current-password"
                  required
                  class="input input-auth"
                  [class.border-red-500]="form.get('password')?.touched && form.get('password')?.invalid"
                >
                <button
                  type="button"
                  (click)="showPassword()"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <!-- Eye Icon - Show Password -->
                  <svg *ngIf="!show_password" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400 hover:text-gray-600 transition-colors">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <!-- Eye Slash Icon - Hide Password -->
                  <svg *ngIf="show_password" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-5 w-5 text-gray-400 hover:text-gray-600 transition-colors">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                  </svg>
                </button>
              </div>
              <div class="pt-3" *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
                <p class="ng-invalid pl-1 text-xs text-red-500" *ngIf="form.get('password')?.errors?.['required']">
                  Password is required.
                </p>
                <p class="ng-invalid pl-1 text-xs text-red-500" *ngIf="form.get('password')?.errors?.['minlength']">
                  Password should be at least 8 characters.
                </p>
                <p class="ng-invalid pl-1 text-xs text-red-500" *ngIf="form.get('password')?.errors?.['maxlength']">
                  Password should be at most 20 characters.
                </p>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="pt-4">
              <button
                type="submit"
                class="w-full btn-auth rounded-lg disabled:opacity-75 disabled:cursor-not-allowed flex items-center justify-center"
                [disabled]="isLoading || form.invalid"
              >
                <span *ngIf="!isLoading">Sign in</span>
                <span *ngIf="isLoading" class="flex items-center justify-center">
                  <svg class="animate-spin mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Signing in...
                </span>
              </button>
            </div>
          </fieldset>
        </form>

        <!-- Sign Up Link -->
        <div class="text-center">
          <p class="text-sm font-medium  text-gray-500">
            You don't have an account?
            <a routerLink="/register" class="font-medium text-auth hover:opacity-90">
              Sign up here
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
